





























/* eslint-disable no-console */

import { attrValue } from "@/misc/attribute-codes";
import TextSelector from "@/components/TextSelector.vue";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { TextEditionDTO, SignDTO } from "@/dtos/sqe-dtos";

@Component({
  components: {
    TextSelector,
    FormattedText
  },
  filters: {
    attrDecode: function(e: SignDTO) {
      return e
        ? e.signInterpretations
            .map(x => x.attributes)
            .flat()
            .map(x => `${x.attributeString.toLowerCase().replace('_', '-')}-${x.attributeValueString.toLowerCase().replace('_', '-')}`)
        : [];
    }
  }
})
export default class FormattedText extends Vue {
  @Prop()
  text!: TextEditionDTO;

  attrMap: { [id: string]: string } = attrValue;

  damaged(sign: SignDTO): boolean {
    const attrs = this.attrDecode(sign);
    return (
      attrs.indexOf("INCOMPLETE_BUT_CLEAR") > -1 ||
      attrs.indexOf("INCOMPLETE_AND_NOT_CLEAR") > -1
    );
  }

  attrDecode(sign: SignDTO): string[] {
    return sign
      ? sign.signInterpretations
          .map(x => x.attributes)
          .flat()
          .map(x => `${x.attributeString.toLowerCase()}-${x.attributeValueString.toLowerCase()}`)
      : [];
  }

  char(sign: SignDTO): string {
    let char = ''
    for (let interpretation of sign.signInterpretations) {
      if (interpretation.character) {
        char = interpretation.character
        break
      }
    }
    return char
  }
}
